// src/kavumainpage/Spinner.js
import React from 'react';
import './Spinner.css'; // We will create this file next

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container"></div>
      <p className="spinner-text">Loading Sree Thalayanneri Poomalakavu...</p>
    </div>
  );
};

export default Spinner;